import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    PREDPOPLACHY_AKTIVNI_URL,
    PREDPOPLACHY_BY_ID_URL,
    PREDPOPLACHY_ODPOVEDI_URL,
    PREDPOPLACHY_DEAKTIVOVAT_URL,
} from "../url";
import type { Predpoplach, PredpoplachOdpoved } from "../generated/models/Predpoplach";

const getAktivni = (deviceToken?: string) =>
    handleRequest<Predpoplach | null>(() => axiosInstance.get(PREDPOPLACHY_AKTIVNI_URL(deviceToken)));

const getById = (id: number) =>
    handleRequest<Predpoplach>(() => axiosInstance.get(PREDPOPLACHY_BY_ID_URL(id)));

const getOdpovedi = (id: number, deviceToken?: string) =>
    handleRequest<PredpoplachOdpoved[]>(() => axiosInstance.get(PREDPOPLACHY_ODPOVEDI_URL(id, deviceToken)));

const deaktivujPredpoplach = (id: number) =>
    handleRequest(() => axiosInstance.post(PREDPOPLACHY_DEAKTIVOVAT_URL(id)));

const PredpoplachService = { getAktivni, getById, getOdpovedi, deaktivujPredpoplach };
export default PredpoplachService;
